export default {
  en: {
    ok: 'OK',
    cancel: 'Cancel',
    close: 'Close',
    language: 'Language',
    confirm: 'Confirm',
    retry: 'Retry',
    back: 'Back',
    scrollToTop: 'Scroll to top',
    searchPlaceholder: 'Search',
    add: 'Add',
    deliveryAddressLabel: 'Delivery address',
    openDeliveryAddress: 'Open delivery address',
    noDeliveryAddress: 'Select address',
    loading: 'Loading…',
    noResults: 'Nothing found',
    comingSoon: 'Coming soon',
    errorLoadProducts: 'Could not load products',
    errorLoadRestaurants: 'Could not load restaurants',
    restaurantDetailAllReviews: 'All reviews',
    restaurantDetailFastDelivery: 'Fast delivery',
    fulfillmentDelivery: 'Delivery',
    fulfillmentPickup: 'Pickup',
    cartOrderFrom: 'Order from',
    cartOrderTitle: 'Order from {restaurant}',
    productWeightGrams: '{weight} g',
    cartPaymentTitle: 'To pay',
    cartLineCount: 'Total items',
    cartGoodsCost: 'Subtotal',
    cartDeliveryCost: 'Delivery',
    cartDiscount: 'Discount',
    cartPromoCode: 'Promo code',
    cartPromoPlaceholder: 'Enter promo code',
    cartPromoAuthNotice: 'Discount calculation will be available after signing in.',
    cartPromoApply: 'Apply',
    cartPromoClear: 'Remove',
    cartPromoApplyFailed: 'Could not apply promo code',
    cartPromoErrors: {
      promo_not_found: 'Promo code not found',
      promo_disabled: 'Promo code is disabled',
      promo_expired: 'Promo code has expired',
      promo_inactive: 'Promotion is not active',
      promo_paused: 'Promotion is paused',
      min_order_amount_not_met: 'Order amount is below the promo minimum',
      min_order_amount_not_met_with_amount: 'Minimum order amount for this promo is {amount}',
      promo_first_order_only: 'Promo is for the first order only',
      promo_usage_limit_reached: 'Promo usage limit reached',
      promo_budget_exhausted: 'Promo budget is exhausted',
      promo_restaurant_not_allowed: 'Promo is not valid for this restaurant',
      basket_empty: 'Cart is empty',
    },
    cartDeliveryQuoteFailed: 'Could not calculate delivery fee',
    cartDeliveryUnavailable: 'Delivery to this address is currently unavailable',
    cartDeliveryErrors: {
      delivery_no_location: 'Select a delivery address to calculate the fee',
      delivery_outside_zone: 'Address is outside the delivery zone',
      restaurant_does_not_deliver_to_zone: 'This restaurant does not deliver to your area',
    },
    cartTotalDue: 'Total due',
    addFoodFrom: 'Add food from',
    placeOrder: 'Place order',
    placeOrderOutsideZone: 'Outside delivery zone',
    placeOrderUnavailable: 'Fix unavailable items',
    cartHasUnavailable: 'Remove or fix unavailable items to place the order',
    productUnavailable: 'This dish is unavailable',
    productStockExceeded: 'Not enough stock for this dish',
    cartKeepMaxQuantity: 'Keep {count}',
    orderPlaced: 'Order placed successfully',
    orderCreateFailed: 'Failed to create order. Please try again.',
    restaurantClosed: 'The restaurant is closed. Ordering is unavailable.',
    restaurantBlocked: 'This restaurant is unavailable.',
    restaurantInactive: 'The restaurant is temporarily not accepting orders.',
    deliveryOutsideZone: 'Address is outside the delivery zone',
    orderPaymentFailedRetry: 'Payment confirmation failed. Retry?',
    cartRemoveItemConfirm: 'Remove "{title}" from cart?',
    cartRemoveItem: 'Remove',
    cartReplaceRestaurantTitle: 'Start a new order?',
    cartReplaceRestaurantMessage:
      'Your cart has items from another restaurant. To continue, the cart will be cleared and this dish will be added.',
    cartReplaceRestaurantAccept: 'OK',
    changeDeliveryAddress: 'Change delivery address',
    cartPaymentMethodsTitle: 'Payment methods',
    paymentMethodInternal: 'From internal account',
    paymentMethodQrRub: 'Pay by QR (rubles)',
    paymentMethodCash: 'Cash payment to courier',
    paymentCashLimitHint: 'Cash payment to courier is available for orders up to ₫ 300 000.',
    paymentCashLimitExceeded:
      'Cash payment is only available for orders up to ₫ 300 000. Please pay online.',
    restaurantCategory: {
      all: 'All',
      russian: 'Russian',
      asian: 'Asian',
      frozen: 'Frozen',
      grill: 'Grill',
      dairy: 'Dairy',
      sushi: 'Sushi & Rolls',
      fastfood: 'Fast food',
      european: 'European',
      mexican: 'Mexican',
      vietnamese: 'Vietnamese',
    },
    restaurantCategoryPage: {
      russian: 'Russian cuisine',
      asian: 'Asian cuisine',
      frozen: 'Frozen',
      grill: 'Grill',
      dairy: 'Dairy',
      sushi: 'Sushi & Rolls',
      fastfood: 'Fast food',
    },
    restaurantMenuSection: {
      all: 'All',
      salads: 'Salads',
      soups: 'Soups',
      hot: 'Hot dishes',
      drinks: 'Drinks',
      grill: 'Grill',
      desserts: 'Desserts',
      breakfasts: 'Breakfasts',
    },
    courierStatusTitle: 'My status',
    courierStatusOnline: 'Online',
    courierStatusOffline: 'Offline',
    courierStatusUpdateFailed: 'Could not update status',
    courierLocationRequired:
      'Allow location access to update your position',
    courierLocationUnavailable:
      'Could not determine your location',
    courierOnDelivery: 'On delivery — finish the order to change status',
    courierStatusBusyConflict: 'Finish the current order before changing online status',
    restaurantStatusTitle: 'Status of restaurant {name}',
    restaurantStatusOpen: 'Open',
    restaurantStatusClosed: 'Closed',
    restaurantStatusToggleAria: 'Restaurant working mode',
    restaurantStatusConfirmOpenTitle: 'Open restaurant?',
    restaurantStatusConfirmOpenMessage:
      'The restaurant will start accepting orders (schedule is ignored).',
    restaurantStatusConfirmOpenAccept: 'Open',
    restaurantStatusConfirmCloseTitle: 'Close restaurant?',
    restaurantStatusConfirmCloseMessage:
      'The restaurant will stop accepting orders (schedule is ignored).',
    restaurantStatusConfirmCloseAccept: 'Close',
    restaurantStatusUpdateFailed: 'Could not update restaurant status',
    restaurantSupportChatTitle: 'Support chat',
    courierNav: {
      home: 'Home',
      orders: 'Orders',
      map: 'Map',
      finance: 'Finance',
    },
    restaurantNav: {
      home: 'Home',
      orders: 'Orders',
      finance: 'Finance',
      catalog: 'Catalog',
    },
    adminNav: {
      home: 'Home',
      orders: 'Orders',
      catalog: 'Catalog',
      productsList: 'Products',
      createProduct: 'New product',
      restaurant: 'Restaurant',
      restaurantsList: 'Restaurants',
      createRestaurant: 'New restaurant',
      ledger: 'Ledger',
      wallets: 'Wallets',
      accounts: 'Accounts',
      transactions: 'Transactions',
      operations: 'Operations',
      users: 'Users',
    },
    clientMenu: {
      openMenu: 'Menu',
      closeMenu: 'Close menu',
      title: 'Account',
      orderHistory: 'Order history',
      orders: 'My orders',
      address: 'My address',
      support: 'Support',
      telegramBot: 'Chat bot in Telegram',
      whatsappBot: 'Chat bot in WhatsApp',
      websiteChat: 'Website chat',
      faq: 'FAQ',
      supportHint: 'Support is available from 9:00 to 22:00 local time in Nha Trang',
      partners: 'For partners',
      invite: 'Invite for a reward',
      settings: 'Settings',
      language: 'Language',
      languageClose: 'Close',
    },
  },
  ru: {
    ok: 'Ок',
    cancel: 'Отмена',
    close: 'Закрыть',
    language: 'Язык',
    confirm: 'Подтверждение',
    retry: 'Повторить',
    back: 'Назад',
    scrollToTop: 'Наверх',
    searchPlaceholder: 'Искать пельмени',
    add: 'Добавить',
    deliveryAddressLabel: 'Адрес доставки',
    openDeliveryAddress: 'Открыть адрес доставки',
    noDeliveryAddress: 'Выберите адрес',
    loading: 'Загрузка…',
    noResults: 'Ничего не найдено',
    comingSoon: 'Скоро',
    errorLoadProducts: 'Не удалось загрузить товары',
    errorLoadRestaurants: 'Не удалось загрузить рестораны',
    restaurantDetailAllReviews: 'Все отзывы',
    restaurantDetailFastDelivery: 'Быстрая доставка',
    fulfillmentDelivery: 'Доставка',
    fulfillmentPickup: 'Самовывоз',
    cartOrderFrom: 'Заказ из',
    cartOrderTitle: 'Заказ из {restaurant}',
    productWeightGrams: '{weight} г',
    cartPaymentTitle: 'К оплате',
    cartLineCount: 'Итого позиций',
    cartGoodsCost: 'Стоимость товаров',
    cartDeliveryCost: 'Стоимость доставки',
    cartDiscount: 'Скидка',
    cartPromoCode: 'Промокод',
    cartPromoPlaceholder: 'Введите промокод',
    cartPromoAuthNotice: 'Расчёт скидок будет доступен после авторизации.',
    cartPromoApply: 'Применить',
    cartPromoClear: 'Снять',
    cartPromoApplyFailed: 'Не удалось применить промокод',
    cartPromoErrors: {
      promo_not_found: 'Промокод не найден',
      promo_disabled: 'Промокод отключён',
      promo_expired: 'Срок действия промокода истёк',
      promo_inactive: 'Акция не активна',
      promo_paused: 'Акция приостановлена',
      min_order_amount_not_met: 'Сумма заказа меньше минимума для промокода',
      min_order_amount_not_met_with_amount: 'Минимальная сумма заказа для промокода — {amount}',
      promo_first_order_only: 'Промокод только на первый заказ',
      promo_usage_limit_reached: 'Лимит использований промокода исчерпан',
      promo_budget_exhausted: 'Бюджет акции исчерпан',
      promo_restaurant_not_allowed: 'Промокод не действует в этом ресторане',
      basket_empty: 'Корзина пуста',
    },
    cartDeliveryQuoteFailed: 'Не удалось рассчитать стоимость доставки',
    cartDeliveryUnavailable: 'Доставка по этому адресу сейчас недоступна',
    cartDeliveryErrors: {
      delivery_no_location: 'Выберите адрес доставки, чтобы рассчитать стоимость',
      delivery_outside_zone: 'Адрес находится вне зоны доставки',
      restaurant_does_not_deliver_to_zone: 'Ресторан не доставляет в ваш район',
    },
    cartTotalDue: 'Итого к оплате',
    addFoodFrom: 'Добавить еды из',
    placeOrder: 'Заказать',
    placeOrderOutsideZone: 'Адрес вне зоны доставки',
    placeOrderUnavailable: 'Исправьте недоступные позиции',
    cartHasUnavailable: 'Уберите или исправьте недоступные позиции, чтобы оформить заказ',
    productUnavailable: 'Блюдо недоступно',
    productStockExceeded: 'Недостаточно остатка для этого блюда',
    cartKeepMaxQuantity: 'Оставить {count}',
    orderPlaced: 'Заказ оформлен',
    orderCreateFailed: 'Не удалось создать заказ. Попробуйте снова.',
    restaurantClosed: 'Ресторан сейчас закрыт. Заказ оформить нельзя.',
    restaurantBlocked: 'Ресторан недоступен.',
    restaurantInactive: 'Ресторан временно не принимает заказы.',
    deliveryOutsideZone: 'Адрес находится вне зоны доставки',
    orderPaymentFailedRetry: 'Не удалось подтвердить оплату. Повторить?',
    cartRemoveItemConfirm: 'Удалить «{title}» из корзины?',
    cartRemoveItem: 'Удалить',
    cartReplaceRestaurantTitle: 'Начать новый заказ?',
    cartReplaceRestaurantMessage:
      'В корзине уже есть блюда из другого ресторана. Чтобы продолжить, корзина будет очищена, и в неё добавится это блюдо.',
    cartReplaceRestaurantAccept: 'Хорошо',
    changeDeliveryAddress: 'Изменить адрес',
    cartPaymentMethodsTitle: 'Способы оплаты',
    paymentMethodInternal: 'Со внутреннего счета',
    paymentMethodQrRub: 'Оплата по QR рублями',
    paymentMethodCash: 'Оплата наличными курьеру',
    paymentCashLimitHint: 'Оплата наличными курьеру доступна для заказов до ₫ 300 000.',
    paymentCashLimitExceeded:
      'Оплата наличными доступна только для заказов до ₫ 300 000. Выберите оплату онлайн.',
    restaurantCategory: {
      all: 'Все',
      russian: 'Русская',
      asian: 'Азиатская',
      frozen: 'Заморозка',
      grill: 'На мангале',
      dairy: 'Молочка',
      sushi: 'Суши и Роллы',
      fastfood: 'Фастфуд',
      european: 'Европейская',
      mexican: 'Мексиканская',
      vietnamese: 'Вьетнамская',
    },
    restaurantCategoryPage: {
      russian: 'Русская кухня',
      asian: 'Азиатская кухня',
      frozen: 'Заморозка',
      grill: 'На мангале',
      dairy: 'Молочка',
      sushi: 'Суши и Роллы',
      fastfood: 'Фастфуд',
    },
    restaurantMenuSection: {
      all: 'Все',
      salads: 'Салаты',
      soups: 'Супы',
      hot: 'Горячее',
      drinks: 'Напитки',
      grill: 'Гриль',
      desserts: 'Десерты',
      breakfasts: 'Завтраки',
    },
    courierStatusTitle: 'Мой статус',
    courierStatusOnline: 'Онлайн',
    courierStatusOffline: 'Оффлайн',
    courierStatusUpdateFailed: 'Не удалось изменить статус',
    courierLocationRequired:
      'Разрешите геолокацию для обновления позиции',
    courierLocationUnavailable:
      'Не удалось определить местоположение',
    courierOnDelivery: 'На доставке — завершите заказ, чтобы сменить статус',
    courierStatusBusyConflict: 'Завершите текущий заказ, чтобы сменить статус линии',
    restaurantStatusTitle: 'Статус ресторана {name}',
    restaurantStatusOpen: 'Открыт',
    restaurantStatusClosed: 'Закрыт',
    restaurantStatusToggleAria: 'Режим работы ресторана',
    restaurantStatusConfirmOpenTitle: 'Открыть ресторан?',
    restaurantStatusConfirmOpenMessage:
      'Ресторан начнёт принимать заказы (расписание не учитывается).',
    restaurantStatusConfirmOpenAccept: 'Открыть',
    restaurantStatusConfirmCloseTitle: 'Закрыть ресторан?',
    restaurantStatusConfirmCloseMessage:
      'Ресторан перестанет принимать заказы (расписание не учитывается).',
    restaurantStatusConfirmCloseAccept: 'Закрыть',
    restaurantStatusUpdateFailed: 'Не удалось изменить статус ресторана',
    restaurantSupportChatTitle: 'Чат поддержки',
    courierNav: {
      home: 'Главная',
      orders: 'Заказы',
      map: 'Карта',
      finance: 'Финансы',
    },
    restaurantNav: {
      home: 'Главная',
      orders: 'Заказы',
      finance: 'Финансы',
      catalog: 'Каталог',
    },
    adminNav: {
      home: 'Главная',
      orders: 'Заказы',
      catalog: 'Каталог',
      productsList: 'Каталог товаров',
      createProduct: 'Новый товар',
      restaurant: 'Ресторан',
      restaurantsList: 'Список ресторанов',
      createRestaurant: 'Новый ресторан',
      ledger: 'Ledger',
      wallets: 'Кошельки',
      accounts: 'Счета',
      transactions: 'Транзакции',
      operations: 'Операции',
      users: 'Пользователи',
    },
    clientMenu: {
      openMenu: 'Меню',
      closeMenu: 'Закрыть меню',
      title: 'Аккаунт',
      orderHistory: 'История заказов',
      orders: 'Мои заказы',
      address: 'Мой адрес',
      support: 'Поддержка',
      telegramBot: 'Чат-бот в Telegram',
      whatsappBot: 'Чат-бот в WhatsApp',
      websiteChat: 'Чат на сайте',
      faq: 'Вопрос-ответ',
      supportHint: 'Поддержка доступна с 9 до 22 часов по местному времени в г. Нячанг',
      partners: 'Партнерам',
      invite: 'Реферальная программа',
      settings: 'Настройки',
      language: 'Язык',
      languageClose: 'Закрыть',
    },
  },
}
